'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' });

var TurnedInNot = function TurnedInNot(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

TurnedInNot = (0, _pure2.default)(TurnedInNot);
TurnedInNot.muiName = 'SvgIcon';

exports.default = TurnedInNot;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/TurnedInNot.js
// module id = 2964
// module chunks = 0